export const PAYMENT_LINK_EDIT_RESTRICTION =
  "Link settings which affect the price cannot be edited, but you can create a new link with a different price.";

export const CLOUD_PROVIDER_ISSUE = {
  type: "doc",
  content: [
    {
      type: "paragraph",
      content: [
        {
          type: "text",
          text:
            "We are currently experiencing a cloud provider issue. Login and API functions are impacted. The status of this DNS issue can be seen and subscribed to "
        },
        {
          type: "text",
          marks: [
            {
              type: "link",
              attrs: {
                href: "https://status.heroku.com/incidents/2453",
                target: "_blank",
                class: null
              }
            }
          ],
          text: "here."
        }
      ]
    }
  ]
};
